import React from 'react';

/** Success or failure feedback for an action the user just took.
 *
 * Declared here rather than per page so the Settings pattern becomes a
 * convention instead of a one-off. Everywhere else in this app a failed
 * request goes to console.error and the user sees nothing at all. */
export type Status = { kind: 'ok' | 'error'; text: string } | null;

interface StatusBannerProps {
  status: Status;
  className?: string;
}

const StatusBanner: React.FC<StatusBannerProps> = ({ status, className = 'mt-6' }) => {
  if (!status) return null;

  return (
    <div
      className={`${className} rounded-md p-3 text-sm ${
        status.kind === 'ok' ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'
      }`}
      role={status.kind === 'error' ? 'alert' : 'status'}
    >
      {status.text}
    </div>
  );
};

export default StatusBanner;
